import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';

interface CategoriaViewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  level: 1 | 2 | 3;
  categoria: any;
}

export function CategoriaViewModal({ 
  open, 
  onOpenChange, 
  level,
  categoria
}: CategoriaViewModalProps) {
  if (!categoria) return null;

  const getLevelInfo = () => {
    switch (level) {
      case 1:
        return { title: 'Detalhes - Categoria Nível 1', color: 'bg-blue-100 text-blue-800' };
      case 2:
        return { title: 'Detalhes - Categoria Nível 2', color: 'bg-green-100 text-green-800' };
      case 3:
        return { title: 'Detalhes - Categoria Nível 3', color: 'bg-purple-100 text-purple-800' };
    }
  };

  const { title, color } = getLevelInfo();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('pt-BR');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {title}
            <Badge className={color}>Nível {level}</Badge>
          </DialogTitle>
          <DialogDescription>
            Informações detalhadas da categoria
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-muted-foreground">Nome</label>
            <p className="text-base">{categoria.nome}</p>
          </div>

          {categoria.descricao && (
            <div>
              <label className="text-sm font-medium text-muted-foreground">Descrição</label>
              <p className="text-base">{categoria.descricao}</p>
            </div>
          )}

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-muted-foreground">Criado em</label>
              <p className="text-sm">{formatDate(categoria.created_at)}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-muted-foreground">Atualizado em</label>
              <p className="text-sm">{formatDate(categoria.updated_at)}</p>
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-muted-foreground">ID</label>
            <p className="text-xs font-mono bg-muted p-2 rounded">{categoria.id}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}